export default __webpack_public_path__ + "static/media/services.0c82d7e2.svg";